export enum ProductionScheduleStatusColor {
  BLUE = 'BLUE',
  GREY = 'GREY',
  RED = 'RED',
  ORANGE = 'ORANGE'
}
